import productUpdates from "@/shared/data/productUpdates.json";

const SEMVER = /^\d+\.\d+\.\d+$/;

/** -1, 0 or 1; anything that is not X.Y.Z sorts first. */
export function compareVersions(a, b) {
  const pa = SEMVER.test(a || "") ? a.split(".").map(Number) : [-1, 0, 0];
  const pb = SEMVER.test(b || "") ? b.split(".").map(Number) : [-1, 0, 0];
  for (let i = 0; i < 3; i += 1) {
    if (pa[i] !== pb[i]) return pa[i] < pb[i] ? -1 : 1;
  }
  return 0;
}

export const BUILD_SHA = process.env.REACT_APP_BUILD_SHA || "dev";

// Newest first; within a release, in the order written.
const SORTED = productUpdates
  .map((update, index) => ({ update, index }))
  .sort((a, b) => compareVersions(b.update.version, a.update.version) || a.index - b.index)
  .map(({ update }) => update);

// Deploys stamp the version and the commit; a local build counts as the newest release.
const IS_LOCAL_BUILD = ["", "dev", "local"].includes(BUILD_SHA);

/** The running version. */
export const APP_VERSION =
  !IS_LOCAL_BUILD && SEMVER.test(process.env.REACT_APP_VERSION || "")
    ? process.env.REACT_APP_VERSION
    : SORTED[0]?.version || "0.0.0";

/** Product updates up to the running version, newest first. */
export const UPDATES = SORTED.filter((u) => compareVersions(u.version, APP_VERSION) <= 0);

/** Updates in releases newer than `lastSeen`. */
export function updatesSince(lastSeen) {
  return UPDATES.filter((u) => compareVersions(u.version, lastSeen) > 0);
}

export function formatUpdateDate(date) {
  const parsed = date ? new Date(`${date}T00:00:00`) : null;
  return parsed && !Number.isNaN(parsed.getTime())
    ? parsed.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" })
    : "";
}
